import { AlertCategory, AlertSystemCondition } from "./alertConfigurations"

export enum VitalThreshold {
   BPM = 35,
   RPM = 12,
}

export enum AlertVariant {
   "#ff4d4f" = "crimson",
   "#e28d00" = "orange",
   "#e6d84a" = "lemon",
   "#8567ad" = "amethyst",
   "#00849e" = "munsell",
   "#eb75b5" = "pink",
   "#d8f999" = "menthol",
   "#c4b4ff" = "lavender",
   "#ffffff" = "white",
   "#474747" = "outer-space",
   "#7781a2" = "cool-gray",
}

export enum VitalStatus {
   OK = "ok",
   RISEN = "risen",
   FALLEN = "fallen",
}

export enum TypefaceVariant {
   "#242f38" = "gunmetal",
   "#ffffff" = "white",
}

export enum AlertSource {
   STATIC = "static",
   WEARABLE = "wearable",
}

export enum ProcessingMethod {
   DYNAMIC = "dynamic",
   STATIC = "static",
}

export interface AlertLevelType {
   id: string
   name: string
}

export interface AlertLevel {
   id: string
   name: string
   type: AlertLevelType
   hasDoorSensor?: boolean
   parents: AlertLevel[]
}

export interface AlertVitals {
   highHeartRate: boolean
   lowHeartRate: boolean
   highRespiratoryRate: boolean
   lowRespiratoryRate: boolean
   highOxygenLevel?: boolean
   lowOxygenLevel?: boolean
}

export interface AlertInmate {
   id: string
   externalId: string
   firstName: string
   middleName?: string | null
   lastName: string
   customIdentifier: string
   bookingNumber?: string | null
}

export interface AlertColor {
   card: string
   icon: string
   typeface: string
}

export interface AlertSound {
   frequency: string
   clip: number
}

export interface AlertMessage {
   recipients: string[]
}

export interface AlertTextMessage extends AlertMessage {
   id: string
   textMessageActivated?: boolean
}

export interface AlertEmailMessage extends AlertMessage {
   id: string
   emailMessageActivated?: boolean
}

export interface AlertChannel extends AlertMessage {
   id: string
   active: boolean
   subject: string
   message: string
}

export type AlertChannelForm = Pick<AlertChannel, "active" | "recipients"> & {
   id?: string
}

export interface AlertConfiguration {
   id: string
   custom: boolean
   name: string
   color: AlertColor
   sound: AlertSound
   systemCondition: AlertSystemCondition | null
   category: AlertCategory
}

export interface ThresholdValue {
   value: number
   duration: number
}

export type AlertThreshold = {
   high: number
   low: number
   highThresholdDuration: number
   lowThresholdDuration: number
   processingMethod: ProcessingMethod
}

export type AlertOxygenLevel = {
   low: number
   lowLevelDuration: number
}

export type AlertDelayPeriod = {
   duration: number
}

export interface Alert {
   id: string
   source?: AlertSource
   level: AlertLevel
   inmate?: AlertInmate
   priority: number
   timestamp: string
   vitals: AlertVitals
   alertConfiguration: AlertConfiguration
   heartRateThreshold: AlertThreshold
   respiratoryRateThreshold: AlertThreshold
   soundPlaying?: boolean
}
